<!--角标-->
<template>
  <div class="ribbon">
    <span>{{ Content }}</span>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  Content: {type: String}
});
</script>

<style lang="scss" scoped>
.ribbon {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 150px;
  height: 150px;
  overflow: hidden;

  &::before, &::after {
    content: "";
    position: absolute;
  }

  &::before {
    left: 8px;
    width: 40px;
    height: 8px;
    border-radius: 8px 8px 0 0;
    background-color: var(--ribbon-primary-color);
    opacity: .6;
  }

  &::after {
    border-radius: 0 8px 8px 0;
    width: 8px;
    height: 40px;
    right: 0;
    bottom: 8px;
    background-color: #57DD43;
    opacity: .6;
  }

  & > span {
    position: absolute;
    top: 20%;
    right: -40%;
    z-index: 2;
    width: 150%;
    height: 40px;
    overflow: hidden;
    transform: rotate(45deg);
    border: 1px dashed;
    box-shadow: 0 0 0 3px #57DD43, 0 21px 5px -18px rgba(0, 0, 0, 0.6);
    background: #57DD43;
    font-size: 16px;

    /* 文本居中 */
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
}
</style>